import React from 'react';
import * as S from 'components/Generics/Header/Header.style';
import logo from 'components/Generics/Header/Logo_ETO.svg';

const Header = (): React.ReactElement => {
    return (
        <S.Header>
            <S.Logo src={logo} alt="social solutions branded app name" />
        </S.Header>
    );
};

export default Header;